module.exports = __webpack_public_path__ + "png/balance5.png?1d762eb00cc262aeef813f55f9c7eb27";